import type { FC, ReactNode } from "react";
import { Link } from "react-router-dom";

export type DistributionTabKey = "groups" | "contacts";

type DistributionTabsProps = {
  active: DistributionTabKey;
  /** タブと同じ行の右端に表示するアクション (新規作成ボタン等) */
  actions?: ReactNode;
};

const TABS: { key: DistributionTabKey; label: string; to: string }[] = [
  { key: "groups", label: "配信グループ", to: "/admin/distribution/groups" },
  { key: "contacts", label: "連絡先管理", to: "/admin/distribution/contacts" },
];

/**
 * 配信先管理 (グループ / 連絡先) を行き来する下線タブ。
 * 右端に actions スロットを持ち、タブと同じ行に配置できる。
 * @param {DistributionTabsProps} props 現在アクティブなタブ + 右端アクション
 * @return {JSX.Element} タブストリップ
 */
export const DistributionTabs: FC<DistributionTabsProps> = ({
  active,
  actions,
}) => {
  return (
    <div className="flex justify-between items-end gap-4 border-b border-slate-200 mb-6">
      <div className="flex gap-6">
        {TABS.map(t => {
          const isActive = active === t.key;
          return (
            <Link
              key={t.key}
              to={t.to}
              className={`relative px-2 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? "text-primary"
                  : "text-base-content/60 hover:text-base-content"
              }`}
            >
              {t.label}
              {isActive && (
                <span className="absolute left-0 right-0 -bottom-px h-0.5 bg-primary" />
              )}
            </Link>
          );
        })}
      </div>
      {actions && <div className="flex gap-2 items-center pb-1">{actions}</div>}
    </div>
  );
};
